module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/close-f26005610f4370ffdc40a69a9f3a8053.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/close.svg
// module id = /t1q
// module chunks = 24